import { useEditorConfig } from '@/components/editor/useEditorConfig';
import { MarkdownImportPlugin } from '@/components/editor/MarkdownImportPlugin';
import { simpleHash } from '@/lib/simpleHash';
import { CheckListPlugin } from '@lexical/react/LexicalCheckListPlugin';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { cn } from '@/lib/utils';

export function Viewer({
  value: markdown,
  className,
}: {
  value: string;
  className?: string;
}) {
  const hash = simpleHash(markdown);
  const viewerConfig = useEditorConfig(hash.toString(), true);

  return (
    <div
      className={cn(
        `border-input flex field-sizing-content w-full rounded-md border bg-transparent
        px-3 py-2 text-base shadow-xs md:text-sm`,
        className,
      )}
    >
      <LexicalComposer key={hash} initialConfig={viewerConfig}>
        <RichTextPlugin
          contentEditable={
            <ContentEditable className="editor-input text-base focus:outline-none md:text-sm" />
          }
          ErrorBoundary={LexicalErrorBoundary}
          placeholder={null}
        />
        <ListPlugin />
        <CheckListPlugin />
        <MarkdownImportPlugin markdown={markdown} />
      </LexicalComposer>
    </div>
  );
}
